import { isNil } from 'lodash';
import { STATIC_COMPONENT_IDS } from '@shared/scenes/workflows/template/ComponentOptionDefaults';
import { isInputComponent, isRelatedCardLookupComponent } from '@shared/scenes/workflows/utils';
import { Field } from './fields/Field';

export interface Entity {
  id: string;
  fields: Map<string, Field | null>;
  allFields: Map<string, Field | null>;
  navigationViewTemplateId: string | null;
  workflowTemplateId: string;
}

export function toCreateWorkflowEntity(
  entity: Entity,
  workflowTemplate?: MBAPI.WorkflowTemplate,
): MBAPI.CreateWorkflowEntity {
  const { allFields, workflowTemplateId } = entity;

  const fields: { [componentId: string]: MBAPI.Scalar.JSON } = {};
  allFields.forEach((value, key) => {
    if (!isNil(workflowTemplate) && isCreateableField(key, workflowTemplate)) {
      fields[key] = value?.toFieldJson() ?? undefined;
    }
  });

  return {
    fields,
    workflowTemplateId,
  };
}

export function isCreateableField(
  fieldKey: string,
  workflowTemplate?: MBAPI.WorkflowTemplate,
): boolean {
  const component = workflowTemplate?.components?.find(c => c.id === fieldKey);
  return (
    !isNil(component) &&
    isInputComponent(component) &&
    !isRelatedCardLookupComponent(component) &&
    component.isServerManaged !== true
  );
}

export function isDeletedEntity(entity?: MBAPI.WorkflowEntity): boolean {
  const deletedAt = entity?.fields?.[STATIC_COMPONENT_IDS.DELETED_AT];
  return !isNil(entity) && !isNil(deletedAt);
}
